// eslint-disable-next-line import/no-unresolved -- a virtual module of vite.blogLanguages.plugin.ts
import blogLanguages from 'virtual:blog-languages';
import type { LanguageCode } from '~/texts/languages';

/**
 * Which languages each blog article exists in, without the articles: the slug → languages index that
 * vite.blogLanguages.plugin.ts builds from the file names of src/content/blog (~2 kB).
 *
 * Code in the main chunk (the language switcher, useDocumentHead, the article route's beforeLoad) takes
 * article languages and slugs from here and must not import ./api: its eager `?meta` glob would move every
 * article's front matter and the article loader map (~127 kB raw, ~14 kB brotli) into the main chunk.
 * src/entities/blog/languages.test.ts keeps this index equal to what ./api reports.
 */
const index = blogLanguages as Readonly<Record<string, readonly LanguageCode[]>>;

/** The slugs of all articles, whatever languages they exist in. */
export function getPostSlugs(): string[] {
  return Object.keys(index);
}

/** The languages an article exists in (its `.mdx` files), in the site's language order; none for an unknown slug. */
export function getPostLanguages(slug: string): LanguageCode[] {
  return Object.prototype.hasOwnProperty.call(index, slug) ? [...index[slug]] : [];
}
